import {
  Box,
  IconClose,
  IconWarningOutline,
  Inline,
  Text,
  buttonStyles,
} from '@treatwell/ui';
import clsx from 'clsx';
import {useState} from 'react';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';
import {selectAppRequestStatus} from '../../store/slices/selectors';
import styles from './BasketErrorMessage.module.css';

export const BasketErrorMessage = () => {
  const {t} = useTranslation();
  const [showMessage, setShowMessage] = useState(true);
  // The banner prompts the user to pick another slot; if the availability page
  // itself fails to load that prompt is meaningless, so dismiss it on error.
  // Reading the shared store declaratively (rather than via a cross-root event)
  // avoids a race with the app's load: the banner mounts asynchronously and
  // would otherwise miss an error that happened before it was ready.
  const appStatus = useSelector(selectAppRequestStatus);

  if (!showMessage || appStatus === 'rejected') return null;

  return (
    <div className={styles.root} data-cy="BasketErrorMessage">
      <Box className={styles.message}>
        <Inline space="base">
          <IconWarningOutline className={styles.messageIcon} size={16} />
          <Text type="caption">
            {t('availabilityError.appointmentNotAvailable')}
          </Text>
          <button
            className={clsx(buttonStyles.button, styles.messageButton)}
            data-cy="BasketErrorMessageCloseButton"
            onClick={() => {
              setShowMessage(false);
            }}
          >
            <IconClose size={16} />
          </button>
        </Inline>
      </Box>
    </div>
  );
};
